import { Controller } from "@hotwired/stimulus";

export default class extends Controller {  
  toggle(){
    const isOpen = this.element.dataset.isOpen === 'true'
    this.element.dataset.isOpen = !isOpen
  }
}
